import React from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'
import {auth} from '../../firebase'
import {
  AffirmationBoard,
  // ChatRoom,
  ProfileScreen,
  HomeScreen,
  JournalScreen,
  ResourceBoard,
  NotFoundScreen
} from '../../screens'
import useStore from '../../hooks/useStore'
import {Login} from '../chat/Login'
import { RoomList } from '../chat/RoomList'
import { AddRoom } from '../chat/AddRoom'
import { ChatRoom } from '../chat/ChatRoom'




export const Navigation = () => {
  const store = useStore()
  function PrivateRoute({ component: Component, authenticated, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) => store.isAuthenticated === true
          ? <Component {...props} />
          : <Redirect to={{ pathname: '/', state: { from: props.location } }} />}
      />
    )
  }
  return (
    <>   
      <Switch>
        <Route exact path={['/', '/home']} component={HomeScreen} />
        <Route exact path='/profile' component={ProfileScreen} />
        <PrivateRoute exact path='/chat' isAuthenticated={true} component={Login} />
        <Route path="/roomlist" component={RoomList} />
        <Route path="/addroom" component={AddRoom}/>
        <Route path="/chatroom/:room" component={ChatRoom} />
        <Route exact path='/board' component={AffirmationBoard} />
        <PrivateRoute path='/journal' isAuthenticated={true} component={JournalScreen} />
        <Route exact path='/resources' component={ResourceBoard} />
        <Route component={NotFoundScreen} />
      </Switch> 
    </>
  )
}

